/* eslint-disable */
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  DialogContentText,
  Grid,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SendIcon from "@mui/icons-material/Send";
import { DataGrid } from "@mui/x-data-grid";
import { useEffect, useState, useContext } from "react";
import { getOrdenEnvio, ordenEnvioAProduccion } from "../../services/OrdenEnvioService";
import WaitingDialog from "../../utils/WaitingDialog";
import AuthContext from "../../contexts/AuthContext";
//
// ###########################################################################
//
const OrdenEnvioDialog = ({
  idOrdenEnvio,
  onEnviaAProduccion,
  onClose,
  setMessage,
  setShowMessage,
}) => {
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [ordenEnvio, setOrdenEnvio] = useState({});
  const [gestionAtencionCliente, setGestionAtencionCliente] = useState({});
  const [esAnteojo, setEsAnteojo] = useState(false);
  const [esArreglo, setEsArreglo] = useState(false);
  const [anteojo, setAnteojo] = useState({});
  const [anteojoTratamientoRows, setAnteojoTratamientoRows] = useState([]);
  const [arreglo, setArreglo] = useState({});
  const [arregloFornituraRows, setArregloFornituraRows] = useState([]);
  const [arregloServicioRows, setArregloServicioRows] = useState([]);
  const [arregloTratamientoRows, setArregloTratamientoRows] = useState([]);
  const [ordenEnvioEstadoRows, setOrdenEnvioEstadoRows] = useState([]);
  const [observaciones, setObservaciones] = useState("");
  const [openDialogEnviaProduccion, setOpenDialogEnviaProduccion] = useState(false);

  const { hasPermission } = useContext(AuthContext);
  const _enviarAProduccion = hasPermission("orden-envio-enviar");

  const tableColumnsTratamiento = [
    {
      field: "ojo",
      headerName: "Ojo",
      align: "center",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.ojo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "codigo_articulo",
      headerName: "Código",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.codigo_articulo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "descripcion_articulo",
      headerName: "Tratamiento",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_articulo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "descripcion_tr_tipo",
      headerName: "Tipo",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_tr_tipo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "descripcion_tr_marca",
      headerName: "Marca",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_tr_marca;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "tiempo_produccion",
      headerName: "Tiempo de Producción",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.tiempo_produccion ? params.row.tiempo_produccion + " DÍAS" : "";
        return _val;
      },
    },
  ];

  const tableColumnsFornitura = [
    {
      field: "codigo_articulo",
      headerName: "Código",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.codigo_articulo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "descripcion_articulo",
      headerName: "Tratamiento",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_articulo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "cantidad",
      headerName: "Cant",
      type: "number",
      align: "right",
      headerAlign: "center",
      flex: 1,
      minWidth: 150,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.cantidad;
        _val = _val ? _val : "";
        return _val;
      },
    },
  ];

  const tableColumnsServicio = [
    {
      field: "codigo_articulo",
      headerName: "Código",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.codigo_articulo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "descripcion_articulo",
      headerName: "Tratamiento",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_articulo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "cantidad",
      headerName: "Cant",
      type: "number",
      align: "right",
      headerAlign: "center",
      flex: 1,
      minWidth: 150,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.cantidad;
        _val = _val ? _val : "";
        return _val;
      },
    },
  ];

  const tableColumnsEstado = [
    {
      field: "estado",
      headerName: "Estado",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.estado;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "ultimo_estado",
      headerName: "Estado actual?",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.ultimo_estado ? "SÍ" : "";
        return _val;
      },
    },
    {
      field: "fecha_estado",
      headerName: "Desde",
      flex: 1,
      headerAlign: "center",
      minWidth: 150,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.fecha_estado;
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "username",
      headerName: "Vendedor/Operador",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.username;
        _val = _val ? _val.toLowerCase() : "";
        return _val;
      },
    },
    {
      field: "observaciones",
      headerName: "Observaciones",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.observaciones;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
  ];

  const tableOptions = {
    disableRowSelectionOnClick: true,
    disableColumnMenu: true,
    disableColumnFilter: true,
    disableColumnSelector: true,
    disableDensitySelector: true,
    hideFooter: true,
    localeText: {
      noRowsLabel: "",
      noResultsOverlayLabel: "",
    },
    sx: {
      "& .MuiDataGrid-cell": {
        fontSize: "0.9em",
      },
      "& .MuiDataGrid-columnHeaders": {
        backgroundColor: "#f5f5f5",
      },
    },
  };
  //
  // ################################################################################
  //
  useEffect(() => {
    const loadOrdenEnvio = async () => {
      setIsDoingSomething(true);
      const response = await getOrdenEnvio(idOrdenEnvio);
      setIsDoingSomething(false);
      if (response.ok) {
        setOrdenEnvio(response.data.data.orden_envio);

        let _gestionAtencionClienteObject = {};
        let _anteojoArreglo = {};
        if (response.data.data.orden_envio_anteojo) {
          _anteojoArreglo = response.data.data.orden_envio_anteojo.anteojo;
        } else {
          _anteojoArreglo = response.data.data.orden_envio_arreglo.arreglo;
        }

        _gestionAtencionClienteObject = {
          codigoGestionAtencion: _anteojoArreglo.codigo_gc,
          fechaCreacionGestionAtencion: _anteojoArreglo.fecha_creacion_gc,
          usuarioGestionAtencion: _anteojoArreglo.usuario,
          nombreApellidoCliente:
            _anteojoArreglo.nombre_cliente + " " + _anteojoArreglo.apellido_cliente,
          fechaNacimientoClienteEdad:
            _anteojoArreglo.fecha_nac_cliente + " - " + _anteojoArreglo.edad_cliente + " años",
          emailCliente: _anteojoArreglo.email_cliente,
          telefonosCliente:
            _anteojoArreglo.telefono_movil_cliente + " " + _anteojoArreglo.telefono_cliente,
        };

        setGestionAtencionCliente(_gestionAtencionClienteObject);

        let _esAnteojo = response.data.data.orden_envio_anteojo ? true : false;
        setEsAnteojo(_esAnteojo);
        setEsArreglo(!_esAnteojo);

        if (_esAnteojo) {
          let _anteojoObject = response.data.data.orden_envio_anteojo.anteojo;

          _anteojoObject = {
            ..._anteojoObject,
            cristalOI:
              _anteojoObject.codigo_articulo_cristal_oi +
              " - " +
              _anteojoObject.modelo_articulo_cristal_oi,
            cristalOD:
              _anteojoObject.codigo_articulo_cristal_od +
              " - " +
              _anteojoObject.modelo_articulo_cristal_od,
            armazonAsol:
              _anteojoObject.codigo_articulo +
              " - " +
              _anteojoObject.descripcion_articulo +
              " - " +
              _anteojoObject.descripcion_ar_as_marca +
              " - " +
              _anteojoObject.modelo_articulo,
            clienteDejaSuAnteojo: _anteojoObject.cliente_deja_su_anteojo
              ? "CLIENTE DEJA SU ANTEOJO"
              : "",
            nombreApellidoCliente:
              _anteojoObject.nombre_cliente + " " + _anteojoObject.apellido_cliente,
            telefonosCliente:
              _anteojoObject.telefono_movil_cliente + " " + _anteojoObject.telefono_cliente,
            fechaNacimientoClienteEdad:
              _anteojoObject.fecha_nac_cliente + " - " + _anteojoObject.edad_cliente + " años",
            tipoDeAnteojo:
              _anteojoObject.tipo_anteojo === "monofocal-cerca"
                ? "Monofocal de cerca"
                : _anteojoObject.tipo_anteojo === "monofocal-lejos"
                  ? "Monofocal de lejos"
                  : _anteojoObject.tipo_anteojo === "monofocal-intermedia"
                    ? "Monofocal intermedia"
                    : _anteojoObject.tipo_anteojo === "bifocal"
                      ? "Bifocal"
                      : _anteojoObject.tipo_anteojo === "multifocal"
                        ? "Multifocal"
                        : _anteojoObject.tipo_anteojo === "ocupacional"
                          ? "Ocupacional"
                          : "",
          };

          setAnteojo(_anteojoObject);
          let _anteojoTratamientoList = response.data.data.orden_envio_anteojo.anteojo.gc_anteojo_tratamiento_list.map((item) => {
            return {
              ...item,
              id: item.id_gc_anteojo_tratamiento,
            };
          });
          setAnteojoTratamientoRows(_anteojoTratamientoList);
        } else {
          let _arregloObject = response.data.data.orden_envio_arreglo.arreglo;

          _arregloObject = {
            ..._arregloObject,
            armazonAsol:
              _arregloObject.codigo_articulo +
              " - " +
              _arregloObject.descripcion_articulo +
              " - " +
              _arregloObject.descripcion_ar_as_marca +
              " - " +
              _arregloObject.modelo_articulo,
            nombreApellidoCliente:
              _arregloObject.nombre_cliente + " " + _arregloObject.apellido_cliente,
            telefonosCliente:
              _arregloObject.telefono_movil_cliente + " " + _arregloObject.telefono_cliente,
            fechaNacimientoClienteEdad:
              _arregloObject.fecha_nac_cliente + " - " + _arregloObject.edad_cliente + " años",
          };

          setArreglo(_arregloObject);
          let _arregloFornituraList = response.data.data.orden_envio_arreglo.arreglo.gc_arreglo_fornitura_list.map((item) => {
            return {
              ...item,
              id: item.id_gc_arreglo_fornitura,
            };
          });
          let _arregloServicioList = response.data.data.orden_envio_arreglo.arreglo.gc_arreglo_servicio_list.map((item) => {
            return {
              ...item,
              id: item.id_gc_arreglo_servicio,
            };
          });
          let _arregloTratamientoList = response.data.data.orden_envio_arreglo.arreglo.gc_arreglo_tratamiento_list.map((item) => {
            return {
              ...item,
              id: item.id_gc_arreglo_tratamiento,
            };
          });
          setArregloFornituraRows(_arregloFornituraList);
          setArregloServicioRows(_arregloServicioList);
          setArregloTratamientoRows(_arregloTratamientoList);
        }

        setOrdenEnvioEstadoRows(response.data.data.orden_envio_estado_list);
      } else {
        setMessage({
          severity: response.messageSeverity,
          messageText: response.messageText,
        });
        setShowMessage(true);
        return;
      }
    };
    loadOrdenEnvio();
  }, []);
  //
  // ################################################################################
  //
  const handleCloseDialog = () => {
    onClose();
  };
  //
  // ################################################################################
  //
  const handleCloseDialogEnviaProduccion = (parEnviaProduccion) => {
    parEnviaProduccion = typeof parEnviaProduccion == "boolean" ? parEnviaProduccion : false;

    if (parEnviaProduccion) {
      enviaAProduccion();
    }
    setOpenDialogEnviaProduccion(false);
  };
  //
  // ################################################################################
  //
  const enviaAProduccion = async () => {
    setIsDoingSomething(true);
    const response = await ordenEnvioAProduccion(idOrdenEnvio, observaciones);
    setIsDoingSomething(false);

    if (response.ok) {
      onEnviaAProduccion();
    }

    setMessage({
      severity: response.messageSeverity,
      messageText: response.messageText,
    });
    setShowMessage(true);
  };
  //
  // ################################################################################
  //
  const handleChange = (e) => {
    setObservaciones(e.target.value);
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Dialog
        open={true}
        onClose={handleCloseDialog}
        maxWidth="xl"
        fullWidth={true}
        scroll="body"
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          Orden de Envío {ordenEnvio.codigo_orden_envio ? ordenEnvio.codigo_orden_envio : ""}
          <IconButton
            aria-label="close"
            onClick={handleCloseDialog}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <Box sx={{ border: "1px solid LightGrey", p: 2, borderRadius: "5px", m: 0, mb: 1 }}>
            <Grid container spacing={1} sx={{ mb: 1 }}>
              <Grid item xs={12} sm={12} md={2} lg={2}>
                <TextField
                  id="codigo_orden_envio"
                  label="Código de Orden de Envío"
                  size="small"
                  sx={{ width: "100%" }}
                  inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                  name="codigo_orden_envio"
                  value={ordenEnvio.codigo_orden_envio ? ordenEnvio.codigo_orden_envio : ""}
                  variant="outlined"
                />
              </Grid>

              <Grid item xs={12} sm={12} md={2} lg={2}>
                <TextField
                  id="fecha_creacion"
                  label="Fecha/hora de generación"
                  size="small"
                  sx={{ width: "100%" }}
                  inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                  name="fecha_creacion"
                  value={ordenEnvio.fecha_creacion ? ordenEnvio.fecha_creacion : ""}
                  variant="outlined"
                />
              </Grid>

              <Grid item xs={12} sm={12} md={2} lg={2}>
                <TextField
                  id="usuario"
                  label="Vendedor"
                  size="small"
                  sx={{ width: "100%" }}
                  inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                  name="usuario"
                  value={ordenEnvio.usuario ? ordenEnvio.usuario : ""}
                  variant="outlined"
                />
              </Grid>
            </Grid>

            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <TextField
                  id="descripcion_area_genera"
                  label="Sucursal que genera"
                  size="small"
                  sx={{ width: "100%" }}
                  inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                  name="descripcion_area_genera"
                  value={
                    ordenEnvio.descripcion_area_genera ? ordenEnvio.descripcion_area_genera : ""
                  }
                  variant="outlined"
                />
              </Grid>

              <Grid item xs={12} sm={12} md={6} lg={6}>
                <TextField
                  id="descripcion_area_envia"
                  label="Sucursal que envía"
                  size="small"
                  sx={{ width: "100%" }}
                  inputProps={{ style: { textAlign: "left", color: "brown" }, readOnly: true }}
                  name="descripcion_area_envia"
                  value={ordenEnvio.descripcion_area_envia ? ordenEnvio.descripcion_area_envia : ""}
                  variant="outlined"
                />
              </Grid>
            </Grid>
          </Box>

          <Box sx={{ border: "1px solid LightGrey", p: 2, borderRadius: "5px", m: 0, mb: 1 }}>
            <Grid container spacing={1} sx={{ mb: 1 }}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <Typography variant="h6" gutterBottom>
                  Gestión de Atención
                </Typography>
              </Grid>
              <Grid item xs={12} sm={12} md={2} lg={2}>
                <TextField
                  id="codigo_gc"
                  label="Código de Gestión de Atención"
                  size="small"
                  sx={{ width: "100%" }}
                  inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                  name="codigo_gc"
                  value={
                    gestionAtencionCliente.codigoGestionAtencion
                      ? gestionAtencionCliente.codigoGestionAtencion
                      : ""
                  }
                  variant="outlined"
                />
              </Grid>

              <Grid item xs={12} sm={12} md={2} lg={2}>
                <TextField
                  id="fecha_creacion_gc"
                  label="Fecha/hora de registración"
                  size="small"
                  sx={{ width: "100%" }}
                  inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                  name="fecha_creacion_gc"
                  value={
                    gestionAtencionCliente.fechaCreacionGestionAtencion
                      ? gestionAtencionCliente.fechaCreacionGestionAtencion
                      : ""
                  }
                  variant="outlined"
                />
              </Grid>

              <Grid item xs={12} sm={12} md={2} lg={2}>
                <TextField
                  id="usuario_gc"
                  label="Vendedor de Gestión de Atención"
                  size="small"
                  sx={{ width: "100%" }}
                  inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                  name="usuario_gc"
                  value={
                    gestionAtencionCliente.usuarioGestionAtencion
                      ? gestionAtencionCliente.usuarioGestionAtencion
                      : ""
                  }
                  variant="outlined"
                />
              </Grid>
            </Grid>

            <Grid container spacing={1} sx={{ mb: 1 }}>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <TextField
                  id="nombreApellidoCliente"
                  label="Nombre y Apellido"
                  size="small"
                  sx={{ width: "100%" }}
                  inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                  name="nombreApellidoCliente"
                  value={
                    gestionAtencionCliente.nombreApellidoCliente
                      ? gestionAtencionCliente.nombreApellidoCliente
                      : ""
                  }
                  variant="outlined"
                />
              </Grid>

              <Grid item xs={12} sm={12} md={6} lg={6}>
                <TextField
                  id="fechaNacimientoClienteEdad"
                  label="Fecha de nacimiento - Edad"
                  size="small"
                  sx={{ width: "100%" }}
                  inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                  name="fechaNacimientoClienteEdad"
                  value={
                    gestionAtencionCliente.fechaNacimientoClienteEdad
                      ? gestionAtencionCliente.fechaNacimientoClienteEdad
                      : ""
                  }
                  variant="outlined"
                />
              </Grid>

              <Grid item xs={12} sm={12} md={6} lg={6}>
                <TextField
                  id="email"
                  label="email"
                  size="small"
                  sx={{ width: "100%" }}
                  inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                  name="email_cliente"
                  value={
                    gestionAtencionCliente.emailCliente ? gestionAtencionCliente.emailCliente : ""
                  }
                  variant="outlined"
                />
              </Grid>

              <Grid item xs={12} sm={12} md={6} lg={6}>
                <TextField
                  id="telefonosCliente"
                  label="Teléfonos"
                  size="small"
                  sx={{ width: "100%" }}
                  inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                  name="telefonosCliente"
                  value={
                    gestionAtencionCliente.telefonosCliente
                      ? gestionAtencionCliente.telefonosCliente
                      : ""
                  }
                  variant="outlined"
                />
              </Grid>
            </Grid>

            {esAnteojo && (
              <>
                <Box sx={{ p: 1, m: 0 }}>
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <Typography variant="h6" gutterBottom>
                        ANTEOJO {anteojo.codigo_gc_anteojo ? anteojo.codigo_gc_anteojo : ""}
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>

                <Box sx={{ border: "1px solid LightGrey", p: 2, borderRadius: "5px", m: 0, mb: 1 }}>
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <Typography variant="subtitle1" gutterBottom>
                        Cristales
                      </Typography>
                    </Grid>

                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <TextField
                        id="tipoAnteojo"
                        label="Tipo de Anteojo"
                        size="small"
                        sx={{ width: "100%" }}
                        inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                        name="tipoDeAnteojo"
                        value={anteojo.tipoDeAnteojo ? anteojo.tipoDeAnteojo : ""}
                        variant="outlined"
                      />
                    </Grid>

                    <Grid item xs={12} sm={12} md={6} lg={6}>
                      <TextField
                        id="cristalOI"
                        label="Cristal para ojo izquierdo"
                        size="small"
                        sx={{ width: "100%" }}
                        inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                        name="cristalOI"
                        value={anteojo.cristalOI ? anteojo.cristalOI : ""}
                        variant="outlined"
                        multiline
                      />
                    </Grid>

                    <Grid item xs={12} sm={12} md={6} lg={6}>
                      <TextField
                        id="cristalOD"
                        label="Cristal para ojo derecho"
                        size="small"
                        sx={{ width: "100%" }}
                        inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                        name="cristalOD"
                        value={anteojo.cristalOD ? anteojo.cristalOD : ""}
                        variant="outlined"
                        multiline
                      />
                    </Grid>

                    <Grid container spacing={2}>
                      <Grid item sm={2}></Grid>
                      <Grid item sm={2}></Grid>
                      <Grid item sm={2}>
                        <Typography component="div" gutterBottom align="left">
                          Distancia pupilar
                        </Typography>
                      </Grid>
                      <Grid item sm={2}>
                        <Typography component="div" gutterBottom align="left">
                          Altura pupilar
                        </Typography>
                      </Grid>
                      <Grid item sm={2}>
                        <Typography component="div" gutterBottom align="left">
                          Altura párpado inferior
                        </Typography>
                      </Grid>
                      <Grid item sm={2}></Grid>
                    </Grid>

                    <Grid container spacing={2}>
                      <Grid item sm={2}></Grid>
                      <Grid item sm={2}>
                        <Typography
                          component="div"
                          gutterBottom
                          align="center"
                          sx={{ fontWeight: "bold" }}
                        >
                          Ojo derecho
                        </Typography>
                      </Grid>
                      <Grid item sm={2}>
                        <TextField
                          id="distancia_pupilar_od"
                          size="small"
                          sx={{ width: "50%" }}
                          inputProps={{ style: { textAlign: "center" }, readOnly: true }}
                          name="distancia_pupilar_od"
                          value={anteojo.distancia_pupilar_od}
                        />
                      </Grid>
                      <Grid item sm={2}>
                        <TextField
                          id="altura_pupilar_od"
                          size="small"
                          sx={{ width: "50%" }}
                          inputProps={{ style: { textAlign: "center" }, readOnly: true }}
                          name="altura_pupilar_od"
                          value={anteojo.altura_pupilar_od}
                        />
                      </Grid>
                      <Grid item sm={2}>
                        <TextField
                          id="altura_parpado_inferior_od"
                          size="small"
                          sx={{ width: "50%" }}
                          inputProps={{ style: { textAlign: "center" }, readOnly: true }}
                          name="altura_parpado_inferior_od"
                          value={anteojo.altura_parpado_inferior_od}
                        />
                      </Grid>
                      <Grid item sm={2}></Grid>
                    </Grid>

                    <Grid container spacing={2}>
                      <Grid item sm={2}></Grid>
                      <Grid item sm={2}>
                        <Typography
                          component="div"
                          gutterBottom
                          align="center"
                          sx={{ fontWeight: "bold" }}
                        >
                          Ojo izquierdo
                        </Typography>
                      </Grid>
                      <Grid item sm={2}>
                        <TextField
                          id="distancia_pupilar_oi"
                          size="small"
                          sx={{ width: "50%" }}
                          inputProps={{ style: { textAlign: "center" }, readOnly: true }}
                          name="distancia_pupilar_oi"
                          value={anteojo.distancia_pupilar_oi}
                        />
                      </Grid>
                      <Grid item sm={2}>
                        <TextField
                          id="altura_pupilar_oi"
                          size="small"
                          sx={{ width: "50%" }}
                          inputProps={{ style: { textAlign: "center" }, readOnly: true }}
                          name="altura_pupilar_oi"
                          value={anteojo.altura_pupilar_oi}
                        />
                      </Grid>
                      <Grid item sm={2}>
                        <TextField
                          id="altura_parpado_inferior_oi"
                          size="small"
                          sx={{ width: "50%" }}
                          inputProps={{ style: { textAlign: "center" }, readOnly: true }}
                          name="altura_parpado_inferior_oi"
                          value={anteojo.altura_parpado_inferior_oi}
                        />
                      </Grid>
                      <Grid item sm={2}></Grid>
                    </Grid>
                  </Grid>
                </Box>

                <Box sx={{ border: "1px solid LightGrey", p: 2, borderRadius: "5px", m: 0, mb: 1 }}>
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <Typography variant="subtitle1" gutterBottom>
                        Armazón / Anteojo de Sol
                      </Typography>
                    </Grid>
                  </Grid>

                  {anteojo.montura_nuevo_cliente === "nuevo" && (
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <TextField
                        id="armazonAsol"
                        label="Código - Descripción - Marca - Modelo"
                        size="small"
                        sx={{ width: "100%" }}
                        inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                        name="armazonAsol"
                        value={anteojo.armazonAsol}
                      />
                    </Grid>
                  )}

                  {anteojo.montura_nuevo_cliente === "cliente" &&
                    anteojo.cliente_deja_su_anteojo && (
                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        <TextField
                          id="cliente_deja_su_anteojo"
                          size="small"
                          sx={{ width: "100%" }}
                          inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                          name="cliente_deja_su_anteojo"
                          value={anteojo.clienteDejaSuAnteojo}
                        />
                      </Grid>
                    )}

                  {anteojo.montura_nuevo_cliente === "cliente" &&
                    !anteojo.cliente_deja_su_anteojo && (
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                          <Typography
                            variant="overline"
                            gutterBottom
                            sx={{ fontWeight: "bold", color: "brown" }}
                          >
                            EL CLIENTE NO DEJO SU ANTEOJO
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                          <TextField
                            id="estado_montura"
                            label="Estado de la montura"
                            size="small"
                            sx={{ width: "100%" }}
                            inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                            name="estado_montura"
                            value={anteojo.estado_montura}
                          />
                        </Grid>

                        <Grid item xs={12} sm={12} md={6} lg={2}>
                          <TextField
                            id="medida_horizontal"
                            label="Medida horizontal"
                            size="small"
                            sx={{ width: "100%" }}
                            inputProps={{ style: { textAlign: "center" }, readOnly: true }}
                            name="medida_horizontal"
                            value={anteojo.medida_horizontal}
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={2}>
                          <TextField
                            id="medida_vertical"
                            label="Medida vertical"
                            size="small"
                            sx={{ width: "100%" }}
                            inputProps={{ style: { textAlign: "center" }, readOnly: true }}
                            name="medida_vertical"
                            value={anteojo.medida_vertical}
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={2}>
                          <TextField
                            id="medida_diagonal"
                            label="Medida diagonal"
                            size="small"
                            sx={{ width: "100%" }}
                            inputProps={{ style: { textAlign: "center" }, readOnly: true }}
                            name="medida_diagonal"
                            value={anteojo.medida_diagonal}
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={2}>
                          <TextField
                            id="medida_puente"
                            label="Medida puente"
                            size="small"
                            sx={{ width: "100%" }}
                            inputProps={{ style: { textAlign: "center" }, readOnly: true }}
                            name="medida_puente"
                            value={anteojo.medida_puente}
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={2}>
                          <TextField
                            id="medida_mayor"
                            label="Medida mayor"
                            size="small"
                            sx={{ width: "100%" }}
                            inputProps={{ style: { textAlign: "center" }, readOnly: true }}
                            name="medida_mayor"
                            value={anteojo.medida_mayor}
                          />
                        </Grid>

                        <Grid item xs={12} sm={12} md={6} lg={4}>
                          <TextField
                            id="perfil"
                            label="Perfil"
                            size="small"
                            sx={{ width: "100%" }}
                            inputProps={{ style: { textAlign: "center" }, readOnly: true }}
                            name="perfil"
                            value={anteojo.perfil}
                          />
                        </Grid>

                        <Grid item xs={12} sm={12} md={6} lg={4}>
                          <TextField
                            id="caracteristica"
                            label="caracteristica"
                            size="small"
                            sx={{ width: "100%" }}
                            inputProps={{ style: { textAlign: "center" }, readOnly: true }}
                            name="caracteristica"
                            value={anteojo.caracteristica}
                          />
                        </Grid>

                        <Grid item xs={12} sm={12} md={6} lg={2}>
                          <TextField
                            id="base"
                            label="base"
                            size="small"
                            sx={{ width: "100%" }}
                            inputProps={{ style: { textAlign: "center" }, readOnly: true }}
                            name="base"
                            value={anteojo.base}
                          />
                        </Grid>
                      </Grid>
                    )}
                </Box>

                {anteojoTratamientoRows.length > 0 && (
                  <Box sx={{ border: "1px solid LightGrey", mb: 1, p: 1, borderRadius: "5px" }}>
                    <Typography variant="h6" sx={{ mb: 1 }}>
                      Tratamientos
                    </Typography>
                    <DataGrid
                      rows={anteojoTratamientoRows}
                      columns={tableColumnsTratamiento}
                      {...tableOptions}
                    />
                  </Box>
                )}

                {anteojo.observaciones_gc_anteojo && (
                  <Box
                    sx={{ border: "1px solid LightGrey", p: 2, borderRadius: "5px", m: 0, mb: 1 }}
                  >
                    <Grid container spacing={1}>
                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        <Typography variant="subtitle1" gutterBottom>
                          Notas y observaciones
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <TextField
                        id="observaciones_gc_anteojo"
                        size="small"
                        sx={{ width: "100%" }}
                        inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                        name="observaciones_gc_anteojo"
                        value={anteojo.observaciones_gc_anteojo}
                        multiline
                      />
                    </Grid>
                  </Box>
                )}
              </>
            )}

            {esArreglo && (
              <>
                <Box sx={{ p: 1, m: 0 }}>
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <Typography variant="h6" gutterBottom>
                        ARREGLO {arreglo.codigo_gc_arreglo ? arreglo.codigo_gc_arreglo : ""}
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>

                <Box sx={{ border: "1px solid LightGrey", p: 2, borderRadius: "5px", m: 0, mb: 1 }}>
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <Typography variant="subtitle1" gutterBottom>
                        Anteojo y Cristales del Cliente
                      </Typography>
                    </Grid>

                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <TextField
                        id="descripcion_anteojo_cristales"
                        label="Anteojo y Cristales del Cliente"
                        size="small"
                        sx={{ width: "100%" }}
                        inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                        name="descripcion_anteojo_cristales"
                        value={
                          arreglo.descripcion_anteojo_cristales
                            ? arreglo.descripcion_anteojo_cristales
                            : ""
                        }
                        variant="outlined"
                        multiline
                      />
                    </Grid>
                  </Grid>
                </Box>

                <Box sx={{ border: "1px solid LightGrey", p: 2, borderRadius: "5px", m: 0, mb: 1 }}>
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <Typography variant="subtitle1" gutterBottom>
                        Armazón / Anteojo de Sol
                      </Typography>
                    </Grid>
                  </Grid>

                  {arreglo.montura_nuevo_cliente === "nuevo" && (
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <TextField
                        id="armazonAsol"
                        label="Código - Descripción - Marca - Modelo"
                        size="small"
                        sx={{ width: "100%" }}
                        inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                        name="armazonAsol"
                        value={arreglo.armazonAsol}
                      />
                    </Grid>
                  )}

                  {arreglo.montura_nuevo_cliente === "cliente" && (
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        <TextField
                          id="estado_montura"
                          label="Estado de la montura"
                          size="small"
                          sx={{ width: "100%" }}
                          inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                          name="estado_montura"
                          value={arreglo.estado_montura}
                        />
                      </Grid>
                    </Grid>
                  )}
                </Box>

                {arregloServicioRows.length > 0 && (
                  <Box sx={{ border: "1px solid LightGrey", mb: 1, p: 1, borderRadius: "5px" }}>
                    <Typography variant="h6" sx={{ mb: 1 }}>
                      Servicios
                    </Typography>
                    <DataGrid
                      rows={arregloServicioRows}
                      columns={tableColumnsServicio}
                      {...tableOptions}
                    />
                  </Box>
                )}

                {arregloTratamientoRows.length > 0 && (
                  <Box sx={{ border: "1px solid LightGrey", mb: 1, p: 1, borderRadius: "5px" }}>
                    <Typography variant="h6" sx={{ mb: 1 }}>
                      Tratamientos
                    </Typography>
                    <DataGrid
                      rows={arregloTratamientoRows}
                      columns={tableColumnsTratamiento}
                      {...tableOptions}
                    />
                  </Box>
                )}

                {arregloFornituraRows.length > 0 && (
                  <Box sx={{ border: "1px solid LightGrey", mb: 1, p: 1, borderRadius: "5px" }}>
                    <Typography variant="h6" sx={{ mb: 1 }}>
                      Fornituras
                    </Typography>
                    <DataGrid
                      rows={arregloFornituraRows}
                      columns={tableColumnsFornitura}
                      {...tableOptions}
                    />
                  </Box>
                )}

                {arreglo.observaciones_gc_arreglo && (
                  <Box
                    sx={{ border: "1px solid LightGrey", p: 2, borderRadius: "5px", m: 0, mb: 1 }}
                  >
                    <Grid container spacing={1}>
                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        <Typography variant="subtitle1" gutterBottom>
                          Notas y observaciones
                        </Typography>
                      </Grid>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <TextField
                        id="observaciones_gc_arreglo"
                        size="small"
                        sx={{ width: "100%" }}
                        inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                        name="observaciones_gc_arreglo"
                        value={arreglo.observaciones_gc_arreglo}
                        multiline
                      />
                    </Grid>
                  </Box>
                )}
              </>
            )}
          </Box>

          {ordenEnvioEstadoRows.length > 0 && (
            <Box sx={{ border: "1px solid LightGrey", mb: 1, p: 1, borderRadius: "5px" }}>
              <Typography variant="h6" sx={{ mb: 1 }}>
                Estados de la Orden de Envío
              </Typography>
              <DataGrid
                rows={ordenEnvioEstadoRows}
                columns={tableColumnsEstado}
                {...tableOptions}
              />
            </Box>
          )}

          {ordenEnvio.action_enviar && (
            <Grid container spacing={1} sx={{ mt: 2, mb: 1 }}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <TextField
                  id="observaciones"
                  label="Observaciones"
                  size="small"
                  sx={{ width: "100%" }}
                  // inputProps={{ style: { textAlign: "left" } }}
                  name="observaciones"
                  value={observaciones}
                  variant="outlined"
                  multiline
                  onChange={handleChange}
                />
              </Grid>
            </Grid>
          )}
        </DialogContent>
        <DialogActions>
          <Box sx={{ textAlign: "right", p: 1 }}>
            {ordenEnvio.action_enviar && _enviarAProduccion && (
              <Button
                sx={{ mr: 1, backgroundColor: "warning" }}
                variant="contained"
                onClick={() => {
                  setOpenDialogEnviaProduccion(true);
                }}
                startIcon={<SendIcon />}
              >
                Enviar a producción
              </Button>
            )}
            <Button sx={{ mr: 1 }} variant="outlined" onClick={handleCloseDialog}>
              Cancelar
            </Button>
          </Box>
        </DialogActions>
      </Dialog>

      {/* >>>> send to production dialog */}

      <Dialog
        open={openDialogEnviaProduccion}
        onClose={handleCloseDialogEnviaProduccion}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Enviar a Producción"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Antes de enviar a producción verificá que el sobre contenga todo lo necesario. Estás
            seguro que querés enviar a producción esta Orden de Envío a producción?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleCloseDialogEnviaProduccion(true)}>
            Enviar a Producción
          </Button>
          <Button onClick={() => handleCloseDialogEnviaProduccion(false)} autoFocus>
            Cancelar
          </Button>
        </DialogActions>
      </Dialog>

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};

export default OrdenEnvioDialog;
